import { View } from 'react-native';

const DEFAULT_SIZE = 8;

export interface NotificationDotProps {
  readonly color: string;
  readonly size?: number;
  readonly borderColor?: string;
  readonly borderWidth?: number;
  readonly testID?: string;
}

export const NotificationDot = ({
  color,
  size = DEFAULT_SIZE,
  borderColor,
  borderWidth = 0,
  testID,
}: NotificationDotProps) => (
  <View
    style={{
      backgroundColor: color,
      borderColor,
      borderRadius: size / 2,
      borderWidth,
      height: size,
      width: size,
    }}
    testID={testID}
  />
);
